import React from "react";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  wrapper:{
    height: "100%",
    textAlign:"left",
    margin: "auto",
    paddingLeft:"10vw",
    paddingTop:"2vw",

  }
}));
function ShowProfile() {
  const classes = useStyles();
  const userDetails = useSelector((state) => state.loginSuccesReducer.data);
  return (
    <div className={classes.wrapper}> 
    
     
    <Typography variant="h4" component="h4" gutterBottom={true} color="primary">
        User Profile
      </Typography>
      <Typography variant="h6" component="h6">
        Display Name : {userDetails.displayName}
      </Typography>
      
      
      <Typography variant="h6" component="h6">
        User Id : {userDetails.userid}
      </Typography>
      
      <Typography variant="h6" component="h6">
        Member Of : {userDetails.memberOf.join(",")}
      </Typography>
   
    </div>
  );
}
export default ShowProfile;
